import React from 'react';
import ChoiceTableItem from './ChoiceTableItem';
import { Container, Col, Popover, OverlayTrigger } from 'react-bootstrap';
import Paragraph from './Paragraph';

const ChoiceTable = (props) => {
  //Funktio käsittelemään valintaklikkauksen, käytetään valintaelementtien sisältä (ChoiceTableItem)
  function handleSelect(e) {
    const val = parseInt(e.target.value)
    const id = e.target.id

    if(val !== props.choice && id !== '') {
      document.getElementById(id).classList.add('choiceSelected')
      document.getElementById(id).setAttribute('aria-selected', true)
      document.getElementById(props.data.id + '-choice' + props.choice).classList.remove('choiceSelected')
      document.getElementById(props.data.id + '-choice' + props.choice).setAttribute('aria-selected', false)
      props.setFocusId(id)
      props.setChoice(val)
    }
  }

  // Alaotsikon esittelemät yleistason ohjeet popoverina
  const popoverSub = (
    <Popover id="popover-sub">
      <Popover.Header as="h3">{ props.data.popover.header}</Popover.Header>
      <Popover.Body>
        { props.data.popover.list.map((item, index) => {
          return <li key={props.data.id + "generalHint" + index}>{item}</li>
        }) }
      </Popover.Body>
    </Popover>
  )

  // Pakottaa popoverin vasemmalle pienissä näytöissä
  const initPlacement = () => {
    if(window.innerWidth < 1000){
      return "left"
    } else {
      return props.popoverDirection
    }
  }

  return (
    <Container role="listbox" aria-describedby={"Valintaosio " + props.data.title} className="" fluid>
      <Col id={props.data.id + "head"} role="heading" aria-level="2" className="choiceSubtitle-green m-1" tabIndex="0">
        { props.data.title }
        <OverlayTrigger trigger={["hover", "focus"]} placement={initPlacement()} overlay={popoverSub}>
          <Container id={props.data.id + "sub"} className="choiceQuestion" tabIndex="0"><Paragraph classes="choiceInfo" text={"?"} /></Container>
        </OverlayTrigger>
      </Col>
      <Col className="m-1">
        <ChoiceTableItem aria-selected="false" data={props.data.options.option5} value={5} choice={props.choice} handleSelect={handleSelect} popoverDirection={props.popoverDirection} />
      </Col>
      <Col className="m-1">
        <ChoiceTableItem aria-selected="false" data={props.data.options.option4} value={4} choice={props.choice} handleSelect={handleSelect} popoverDirection={props.popoverDirection} />
      </Col>
      <Col className="m-1">
        <ChoiceTableItem aria-selected="true" data={props.data.options.option3} value={3} choice={props.choice} handleSelect={handleSelect} popoverDirection={props.popoverDirection} />
      </Col>
      <Col className="m-1">
        <ChoiceTableItem aria-selected="false" data={props.data.options.option2} value={2} choice={props.choice} handleSelect={handleSelect} popoverDirection={props.popoverDirection} />
      </Col>
      <Col className="m-1">
        <ChoiceTableItem aria-selected="false" data={props.data.options.option1} value={1} choice={props.choice} handleSelect={handleSelect} popoverDirection={props.popoverDirection} />
      </Col>
    </Container>
  );
};

export default ChoiceTable;